__turbopack_context__.v({
  "appliedButton": "ZbpqvW_appliedButton",
  "applyButton": "ZbpqvW_applyButton",
  "arrowTone": "ZbpqvW_arrowTone",
  "referTone": "ZbpqvW_referTone",
  "relativeTone": "ZbpqvW_relativeTone",
});
